import configureAxios from 'configure/axios';

const axios = configureAxios();

export const fetchFiltered = (brand, capacity, page = 1, page_size) => axios.get('devices/', { params: { brand, capacity, page, page_size } });
export const find = (id) => axios.get(`devices/${id}/`);
